/* External dependencies */
import React from 'react';
import get from 'lodash/get';

/* Internal dependencies */
import MediaObject, { Props as MediaObjectProps } from '../mediaObject/MediaObject';
import { User as UserType } from 'src/types/User';
import { formatNumber } from 'src/common/helpers/numbers';
import UserDefaultAvatar from './UserDefaultAvatar';
import { capitalizeFirstLetter } from 'src/store/helpers/users';
import Icon, { Icons } from 'src/icon/Icon';

type OwnProps = {
  user: UserType;
  right?: React.ReactNode;
} & Partial<MediaObjectProps>;

type Props = OwnProps;

const User: React.FunctionComponent<Props> = ({ user, right, ...rest }) => {
  const createdEvents = get(user, 'createdEvents', []);
  const createdEventsTotal = get(user, 'createdEventsTotal', createdEvents.length);
  const pastEvents = get(user, 'pastEvents', []);
  const pastEventsTotal = get(user, 'pastEventsTotal', pastEvents.length);
  const createdAndAttendedEventsTotal = createdEventsTotal + pastEventsTotal;
  const userImageUrl = get(user, 'images[0].url');
  const verified = get(user, 'verified', false);
  const textColor = get(rest, 'textColor');
  let name = get(user, 'name');
  let lastName = get(user, 'lastName');

  name = capitalizeFirstLetter((name || '').trim());
  lastName = capitalizeFirstLetter((lastName || '').trim());

  return (
    <MediaObject
      text={(
        <div className="d-flex align-items-center" style={{ width: '100%' }}>
          <span className={`${textColor === 'light' ? 'text-light' : 'text-dark'}`}>
            {`${name}${Boolean(lastName) ? ` ${lastName}` : ''}`}
          </span>
          {Boolean(verified) && (
            <Icon
              name={Icons.verified}
              size={16}
              solid
              className="bm-Icon--primary ml-1"
            />
          )}
        </div>
      )}
      subtext={Boolean(createdAndAttendedEventsTotal) ? `${Boolean(createdEventsTotal) ? `${formatNumber(createdEventsTotal)} hosted, ` : ''}${formatNumber(pastEventsTotal)} attended` : undefined}
      imageType="circle"
      image={Boolean(userImageUrl) ? userImageUrl : (
        <UserDefaultAvatar
          user={user}
          size={get(rest, 'imageSize') as number}
        />
      )}
      right={right}
      {...rest}
    />
  );
};

export default User;
